export default {
  namespaced: true,

  state: {
    documents: null,
    fieldRules: {},
    fieldRulesTriggered: 0, // TODO temporary solution to update the screen based on the rules
  },

  getters: {
    getFieldValue: (state, getters, rootState) => fieldName => {
      for (const document of rootState.documents) {
        for (const field of document.fields) {
          if (field.name === fieldName) {
            return field.value;
          }
        }
      }

      return null;
    },
  },

  mutations: {
    addFieldRule(state, { type, target, value, fieldName }) {
      if (!state.fieldRules[fieldName]) {
        state.fieldRules[fieldName] = {};
      }

      if (!state.fieldRules[fieldName][target]) {
        state.fieldRules[fieldName][target] = [];
      }

      const lastItem =
        state.fieldRules[fieldName][target][
          state.fieldRules[fieldName][target].length - 1
        ];
      if (lastItem) {
        if (
          lastItem.type === type &&
          lastItem.value === value &&
          lastItem.target === target
        ) {
          // It is a repeated item, do not add
          // because the buildRules in HRField component builds rules once the component is created
          return;
        }
      }
      state.fieldRules[fieldName][target].push({ type, value, target });
    },

    // TODO temporary solution to update the screen based on the rules
    triggerFieldRules(state) {
      state.fieldRulesTriggered++;
    },
  },

  actions: {
    addFieldRule({ commit }, payload) {
      commit('addFieldRule', payload);
    },
  },
};
